import RoadmapIcon from "@atlaskit/icon/core/roadmap";
import {token} from "@atlaskit/tokens";
import {useState, type MouseEvent} from "react";
import {useCheckMobile} from "~/hooks/useCheckMobile";
import {AnankeIconButton} from "@vesta/ananke/components/anankeIconButton";
import {AnankeTooltip} from "@vesta/ananke/components/anankeTooltip";

export function KanbanCardDispositionControl({
    label,
    tooltip,
    onClick: _onClick,
    compact = false,
}: {
    label: string;
    tooltip?: string;
    /** Kept for call-site compatibility; does not open the disposition side panel. */
    onClick?: () => void;
    /** Icon-only for narrow kanban cards; tooltip shows label when set. */
    compact?: boolean;
}) {
    const isMobile = useCheckMobile();
    const [mobilePillOpen, setMobilePillOpen] = useState(false);

    const tooltipContent =
        tooltip !== undefined && tooltip.trim() !== ""
            ? tooltip
            : label.trim() !== "" && label !== "?"
              ? label
              : "Disposition";

    const handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        event.preventDefault();
        if (isMobile === true) {
            setMobilePillOpen((prev) => !prev);
        }
    };

    const button = (
        <AnankeIconButton
            type="button"
            spacing="compact"
            appearance="subtle"
            icon={RoadmapIcon}
            label="Disposition"
            onClick={handleButtonClick}
        />
    );

    const labelSpan =
        compact !== true && label.trim() !== "" && label !== "?" ? (
            <span
                className="line-clamp-1 text-[0.75rem] font-ds-font-weight-medium leading-ds-space-200"
                style={{fontFamily: "Inter", color: token("color.text.subtle")}}
            >
                {label}
            </span>
        ) : null;

    const mobilePill =
        isMobile === true && mobilePillOpen === true ? (
            <span
                className="absolute right-0 top-[calc(100%+4px)] z-20 line-clamp-4 max-w-[240px] rounded-[3px] px-ds-space-075 py-ds-space-025"
                style={{
                    background: token("color.background.neutral.bold"),
                    color: token("color.text.inverse"),
                    fontFamily: "Inter",
                    fontSize: "12px",
                    lineHeight: "16px",
                    whiteSpace: "pre-wrap",
                    pointerEvents: "none",
                }}
            >
                {tooltipContent}
            </span>
        ) : null;

    return (
        <div
            className="relative inline-flex shrink-0 items-center gap-x-ds-space-075 min-w-0 max-w-full"
            onClick={(event) => {
                event.stopPropagation();
            }}
            onPointerDown={(event) => {
                event.stopPropagation();
            }}
        >
            {labelSpan}
            {isMobile === true ? (
                button
            ) : (
                <AnankeTooltip content={tooltipContent} position="bottom">
                    {(tooltipProps) => <span {...tooltipProps}>{button}</span>}
                </AnankeTooltip>
            )}
            {mobilePill}
        </div>
    );
}
